import React from "react";
import PropTypes from "prop-types";
import Typography from "../Typography";
import Media from "../Carousel/CarouselMedia"
import Image from "next/image";
import styles from '../Carousel/Carousel-tw-styles';
import classNames from "classnames";
import {
    contentBorderImage,
    emptyStar,
    filledStar,
    successImgIcon,
} from '../../../constants/messages/pt-BR';

const RatingStarSection = ({ comment, username, raitingNumber }) => {
    const ratingValue = typeof raitingNumber === 'number' ? raitingNumber : 0;
    return (
        <div
            className="mt-5 md:mt-20 block"
            tabIndex={0}
            role="img"
            aria-label={`${ratingValue} de 5 estrelas`}
            aria-live="polite"
        >
            <div className="star_wrapper">
                <div
                    className="w-120 h-20 mb-10 md:mb-15 mx-auto"
                    style={{ backgroundImage: `url(${emptyStar})` }}
                >
                    <div
                        className={"h-20"}
                        style={{
                            width: `${(ratingValue / 5) * 100}%`,
                            backgroundImage: `url(${filledStar})`,
                        }}
                    ></div>
                </div>
                <Typography
                    className="review_comment px-15 md:px-0 text-10 md:text-15 comment-section mt-15 md:mt-10 md:leading-24 md:tracking-1.74 text-black font-HelveticaNeueBold text-center reviewSize"
                    dangerouslySetInnerHTML={{
                        __html: DOMPurify.sanitize(comment),
                    }}
                    component="p"
                />
                <p className="text-10 md:text-18 md:leading-24 mt-10 md:mt-40 tracking-[0.38px] text-greyDarker text-center font-HelveticaNeueMedium  ">
                    {username}
                </p>
            </div>
        </div>
    );
};
const RatingAndReviewSection = ({
    title,
    subtitle,
    footerTest,
    ratingTitle,
    bannerImage,
    brandSuccessTextCollection,
    isMobile,
    ratingNumber,
    comment,
    username,
    isNoWidth
}) => {
    return (
        <div className="rating_review_container relative md:min-h-min overflow-hidden">
           {/* <picture>
             <source
                 srcSet={bannerImage?.desktopImage?.url}
                 media="(min-width: 1024px)"
             />
             <img className={classNames(styles.carouselImg, "w-full h-auto md:min-h-min object-center")}
                 loading={"auto"}
                 src={bannerImage?.smartphoneImage?.url}
                 alt={bannerImage?.altText}
             />
           </picture> */}
            <Media
                isNoWidth={isNoWidth}
                isLazyLoad
                component="bannerPicture"
                srcset={bannerImage?.desktopImage?.url}
                image={bannerImage?.smartphoneImage?.url}
                altText={bannerImage?.altText}
                priority={true}
                className="w-full h-auto object-center"
            />
            {title && 
            <div className="overflow-hidden absolute grid grid-cols-1 md:grid-cols-3 gap-5 right-0 md:right-15 top-40 md:top-20 left-30p md:left-28p xl:top-20p w-75pp">
                <div
                    className="product_description px-15 md:px-0 flex flex-col md:col-span-2"
                    style={
                        !isMobile
                            ? {
                                borderRight: "20px solid transparent",
                                borderImage: `url(${contentBorderImage.desktop}) 30 stretch`,
                            }
                            : null
                    }
                >
                    <h2 className="color-gradient-yellow-stack text-30 leading-30 md:leading-50 md:text-50 font-BebasNeueBold text-center tracking-wide md:tracking-4">
                        {title}
                    </h2>
                    <Typography
                        component="p"
                        className="text-black text-11 md:text-18 md:leading-24 md:tracking-1.74 text-center mt-10 px-30 ratingSectionSecondPara"
                        dangerouslySetInnerHTML={{
                            __html: DOMPurify.sanitize(subtitle),
                          }}
                    />
                    <div className="flex justify-center flex-col md:flex-row flex-grow items-center mt-10 md:mt-20 gap-5 pl-35 pr-25">
                        {brandSuccessTextCollection?.items &&
                            brandSuccessTextCollection?.items.map(
                                (item, index) => (
                                    <div
                                        key={index}
                                        className="flex items-center md:block ratingWidth"
                                    >
                                    <div className="md:h-45 md:w-45 h-25 w-25 mx-auto imageRatingSection">
                                            <Image
                                                width={45}
                                                height={45}
                                                src={successImgIcon}
                                                className="w-auto h-auto"
                                                alt={"Success Img"}
                                            />
                                        </div>
                                        <Typography
                                            component="p"
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(item?.body),
                                              }}
                                            className="text-black flex-1 ml-10 md:ml-0 text-10 md:text-18 md:leading-24 tracking-wide md:tracking-1.74 text-left md:text-center md:mt-10"
                                        />
                                    </div>
                                )
                            )}
                    </div>
                    <div className="mt-20 hidden md:block text-black w-80p text-11 text-center mx-auto font-HelveticaNeueMedium ratingFooter">
                        <Typography component="p"  dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(footerTest),
                                              }} />
                    </div>
                </div>
                <div className="rating_review col-span-1 hidden md:block">
                    <h3 className="color-gradient-yellow-stack text-50 mt-30 font-BebasNeueBold text-center tracking-4">
                        {ratingTitle}
                    </h3>
                    {ratingNumber && <RatingStarSection
                        raitingNumber={ratingNumber}
                        comment={comment}
                        username={username}
                    />}
                </div>
            </div>}
            {footerTest && <div className="absolute bottom-40 left-0 right-0 flex md:hidden flex-col mob-section-review">
                <div
                    className="text-black w-80p text-11 text-center mx-auto font-HelveticaNeueMedium"
                    style={{
                        borderBottom: "16px solid transparent",
                        borderImage: `url(${contentBorderImage.mobile}) 30 stretch`,
                    }}
                >
                    <Typography component="p" dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(footerTest),
                                              }} />
                </div>
                {ratingTitle &&
                <div className="rating_review">
                    <h3 className="color-gradient-yellow-stack text-30 tracking-wide mt-10 font-BebasNeueBold text-center">
                        {ratingTitle}
                    </h3>
                    <RatingStarSection
                        raitingNumber={ratingNumber}
                        comment={comment}
                        username={username}
                        isMobile={isMobile}
                    />
                </div>}
            </div>}
        </div>
    );
};

RatingAndReviewSection.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string.isRequired,
    ratingSection: PropTypes.object,
    brandSuccessTextCollection: PropTypes.array,
    bannerImage: PropTypes.object,
    footerTest: PropTypes.string,
    isMobile: PropTypes.bool,
    ratingTitle: PropTypes.string,
    raitingNumber: PropTypes.number,
    comment: PropTypes.string,
    username: PropTypes.string,
};

RatingStarSection.propTypes = {
    data: PropTypes.object.isRequired,
    isMobile: PropTypes.bool,
    ratingTitle: PropTypes.string,
    raitingNumber: PropTypes.number,
    comment: PropTypes.string,
    username: PropTypes.string,
};

export default RatingAndReviewSection;
